import { forwardRef, useEffect, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import FormCreator from '../../../../components/Forms/FormCreator'
import { MembershipSubscriptionData } from './MembershipSubscription.data'
import { decryptAESID } from '../../../../utils/Encryption'
import { useParams } from "react-router-dom";

const MembershipSubscription = forwardRef((props, ref) => {
  const { applicationTypeId } = props?.membershipDetails;
  const { id } = useParams();
  const memberId = id ? decryptAESID(id, false) : 0;
  const [formData, setFormData] = useState(MembershipSubscriptionData);

  // useEffect(() => {
  //   debugger
  //   if (applicationTypeId === 2) {
  //     const updatedFormData = {
  //       ...formData, formFields: formData.formFields.map((field) => field.id === "linkedMember" ? {
  //         ...field,
  //         fieldSetting: {
  //           ...field.fieldSetting,
  //           isDisable: false,
  //         },
  //       }
  //         : field
  //       ),
  //     }
  //     setFormData(updatedFormData);
  //   }
  // }, [applicationTypeId])
  return (
    <>
      <Accordion title="Membership Subscription" button={false}>
        <div className="row">
          <FormCreator
            ref={ref}
            {...formData}
          />
        </div>
      </Accordion>
   
    </>
  )
})

export default MembershipSubscription
